<template>
  <div>
    <b-row>
      <b-col xl="5" lg="6" class="mb-6">
        <box>
          <h2>{{ $t('campaignDetails') }}</h2>
          <b-form-group label="Site" label-for="status">
            <multi-select
              v-model="form.site"
              btn-label="Site"
              size="lg"
              :select-options="sites"
            />
          </b-form-group>
          <b-form-group label="Ad Zone name" label-for="adzone-name">
            <b-form-input
              id="adzone-name"
              type="text"
              size="lg"
              v-model="form.name"
              required
            />
          </b-form-group>

          <h2 class="mt-8">Ad Specifications</h2>
          <b-form-group label="Border" label-for="border">
            <multi-select
              v-model="form.border"
              btn-label="Border Type"
              size="lg"
              :select-options="borderTypes"
            />
          </b-form-group>
          <b-form-group label="Format" label-for="adzone-format">
            <multi-select
              v-model="form.adFormat"
              btn-label="Format"
              size="lg"
              :select-options="adFormats"
            />
          </b-form-group>
          <b-form-group label="Category" label-for="adzone-category">
            <b-form-input
              id="adzone-category"
              disabled
              type="text"
              size="lg"
              v-model="form.category"
              required
            />
          </b-form-group>
          <b-form-group
            label="Subcategory (optional)"
            label-for="adzone-subcategory"
          >
            <multi-select
              v-model="form.subcategory"
              btn-label="Select subcategory"
              size="lg"
              :select-options="subcategories"
            />
          </b-form-group>
        </box>
      </b-col>

      <b-col xl="5" lg="6">
        <box>
          <h2>Ad Filtering</h2>
          <b-form-group label="Block Ad Type" label-for="adzone-block-types">
            <multi-select
              :options="multipleSelect"
              v-model="form.blockTypes"
              btn-label="Select types"
              size="lg"
              :select-options="blockTypes"
            />
          </b-form-group>
          <b-form-checkbox
            id="googleCompliance"
            class="mb-2"
            v-model="googleCompliance"
            :value="true"
            :unchecked-value="false"
          >
            Google Ad Compliance
          </b-form-checkbox>
          <div v-if="googleCompliance" class="clearfix">
            <div
              v-for="(type, index) in googleComplianceTypes"
              :key="index"
              class="btn-outline-light disabled btn btn-sm mr-2"
            >
              {{ type }}
            </div>
          </div>
          <b-form-group
            class="mt-4"
            label="Block Speciffic Products"
            label-for="adzone-products"
          >
            <multi-select
              :options="multipleSelect"
              v-model="form.products"
              btn-label="Select products"
              size="lg"
              :select-options="products"
            />
          </b-form-group>

          <h2 class="mt-8">Advanced options</h2>
          <label class="col-form-label pt-0" for="adzone-floor-cpm">
            Floor CPM
            <svg-icon
              id="floorCpmDesc"
              icon="question-circle"
              class="icon-sm align-top txt-3-alt"
            />
          </label>
          <b-form-input
            id="adzone-floor-cpm"
            class="mb-4"
            type="text"
            size="lg"
            v-model="form.floorCpm"
          />
          <label class="col-form-label pt-0" for="adzone-floor-type">
            Floor Type
            <svg-icon
              id="floorTypesDesc"
              icon="question-circle"
              class="icon-sm align-top txt-3-alt"
            />
          </label>
          <multi-select
            v-model="form.floorType"
            btn-label="Select Floor"
            class="mb-4"
            size="lg"
            :select-options="floorTypes"
          />
          <b-form-group
            label="Alternate HTML code"
            label-for="adzone-alternate-code"
          >
            <b-form-textarea
              id="adzone-alternate-code"
              :rows="5"
              size="lg"
              v-model="form.alternateCode"
            />
          </b-form-group>
          <div class="d-flex justify-content-between mt-7">
            <b-button size="lg" variant="outline-light" @click="$router.go(-1)">
              Previous
            </b-button>
            <b-button size="lg" variant="primary"> Save </b-button>
          </div>
        </box>
      </b-col>
    </b-row>

    <b-tooltip target="floorTypesDesc">
      <div class="text-left">
        <b>Soft Floor:</b> We will also run CPC and CPA campaigns that have an
        average eCPM higher to your floor CPM. It means the floor is not 100%
        guaranteed. <br /><br />
        <b>Hard Floor:</b>We will run only CPM and Smart CPM campaigns. Floor
        will be 100% guaranteed.
      </div>
    </b-tooltip>

    <b-tooltip target="floorCpmDesc">
      <div class="text-left">
        Set a minimum CPM and alternate HTML tag to be shown if we can't meet
        this floor CPM.
      </div>
    </b-tooltip>
  </div>
</template>

<script>
const sites = ['hashrunner.com', 'hashfarm.com', 'coindesk.live'];
const borderTypes = ['No Border', '1px', '2px'];
const adFormats = ['Banner 468x60', 'Square 250x250', 'Banner 900x250'];
const blockTypes = [
  'Simple Images',
  'Auto-sound',
  'Misleading Elements',
  'Age Verification',
  'Blinking Elements'
];
const products = ['Crypto - Bitcoin', 'Crypto - Stats', 'Crypto - Wallets'];
const floorTypes = ['Soft Floor', 'Hard Floor'];
const subcategories = ['Wallet', 'Monitoring', 'Trading', 'Exchange'];

export default {
  data() {
    return {
      sites: sites,
      borderTypes: borderTypes,
      adFormats: adFormats,
      blockTypes: blockTypes,
      products: products,
      floorTypes: floorTypes,
      subcategories: subcategories,
      googleCompliance: false,
      googleComplianceTypes: [
        'Auto-sound',
        'Misleading Elements',
        'Age Verification'
      ],
      form: {
        site: ['hashrunner.com'],
        name: '',
        border: ['No Border'],
        adFormat: ['Banner 468x60'],
        blockTypes: [],
        products: [],
        floorCpm: 0.0,
        floorTypes: [],
        alternateCode: '',
        category: 'Crypto',
        subcategory: []
      },
      multipleSelect: {
        multi: true
      }
    };
  }
};
</script>

<style lang="scss">
.col-form-label {
  i {
    margin-top: 3px;
    margin-left: 3px;
  }
}
</style>
